"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.7 9.563a1.3 1.3 0 0 0-1.3 1.3v3.59a1.3 1.3 0 0 0 1.3 1.3h8.6a1.3 1.3 0 0 0 1.3-1.3v-3.59a1.3 1.3 0 0 0-1.3-1.3h-1.243a.6.6 0 0 0-.472.227 3.31 3.31 0 0 1-5.17 0 .6.6 0 0 0-.472-.227zm-2.7 1.3a2.7 2.7 0 0 1 2.7-2.7h1.243c.609 0 1.185.277 1.565.752a1.91 1.91 0 0 0 2.984 0c.38-.475.956-.752 1.565-.752H14.3a2.7 2.7 0 0 1 2.7 2.7v3.59a2.7 2.7 0 0 1-2.7 2.7H5.7a2.7 2.7 0 0 1-2.7-2.7z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.9 12.498a.7.7 0 0 1 .7-.7h2.8a.7.7 0 1 1 0 1.4H8.6a.7.7 0 0 1-.7-.7m2.136-4.135a.7.7 0 0 0 .498-.215l1.489-1.547a.7.7 0 0 0-1.01-.97l-.284.295v-2.38a.7.7 0 1 0-1.4 0v2.427l-.352-.352a.7.7 0 1 0-.99.99l1.547 1.547a.7.7 0 0 0 .502.205",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ArchiveIcon20.js.map